import React, { Component, Dispatch } from 'react';
import { IAction, IAppState } from '../../../../models/action/core';
import { IVideoContentProps } from '../../../../models/components/video-panel';
import * as types from '../../../../models/action/video';
import { connect } from 'react-redux';
import Questions from './question';
import Translator from '../../../../core/i18n';
import { Button } from '../../../../components/ui-elements/main';

const T = Translator.create();

export class CVideoContent extends Component<IVideoContentProps, any> {

     myRef: React.RefObject<HTMLDivElement>;

    constructor(props: any) {
        super(props);
        this.state = {
            questionData: this.props.questionData,
            videoUrl: '',
        };
        this.onClickAddQuestionButton = this.onClickAddQuestionButton.bind(this);
        this.onClickDeleteQuestionButton = this.onClickDeleteQuestionButton.bind(this);
        this.myRef = React.createRef();
    }

    public AddEmptyQuestion(): types.IQuestionData {
        return {
            questionId: '',
            continueEvenWrong: false,
            goBackTo: 0,
            question: '',
            questionType: 0,
            showOnSecond: 1,
            videoTestChoices: null
        };
    }

    public onClickAddQuestionButton() {
        const questionData = this.props.questionData;
        questionData!.questions.push(this.AddEmptyQuestion());
        this.setState({ questionData });
    }
    componentDidUpdate(): void {
          this.myRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start"
          });
    }

    public onClickDeleteQuestionButton(questionIndex: number) {
        if (this.state) {
            const questionData = this.props.questionData;
            questionData!.questions.splice(questionIndex, 1);
            this.setState({ questionData });
            this.myRef = React.createRef();
        }
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_videoContentTab' ? ' show active' : '')}
                id="video"
                role="tabpanel"
                aria-labelledby="video-tab"
            >
                <div className="row">
                    <div className="col-md-12">
                        <div className="question-vides mb-4">
                            <p className="half-color mb-4">{T.t('r_add_video_question')}</p>
                            <Button
                                text={T.t('r_smart_video_question')}
                                onClick={this.onClickAddQuestionButton}
                                button_type={'primary'}
                                size={'medium'}
                                materialicon='add'
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="accordion question-accord" id="accordionExample">
                            {this.props.questionData!.questions &&
                                this.props.questionData!.questions.map((question: any, index: number) => (
                                    <Questions
                                        deleteQuestion={this.onClickDeleteQuestionButton}
                                        questionData={this.props.questionData}
                                        key={index + '-que'}
                                        question={question}
                                        index={index}
                                        questionRef={this.myRef}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (State: IAppState, ownProps: IVideoContentProps): IVideoContentProps => {
    if (!State) {
        return ownProps;
    }

    const questionDataObj: any = State.video;

    const newProps: IVideoContentProps = Object.assign({}, ownProps, {
        questionData: questionDataObj.questionData
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.video.questionData === prev.video.questionData;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const VideoContentPanel = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CVideoContent);

export default VideoContentPanel;
